import { Navigate } from "react-router-dom";
import { FINANCE_ROUTE, HOME_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from "../../entities/my";

export default function AdminTransactionsPage() {

    const {my} = useAppSelector(s => s.myReducer)
    const isAccess = hasFeature(my, FEATURE_SECTIONS.FINANCE)
        && hasFeatureGrant(my, FEATURES.TRANSACTIONS.LIST)
    
    if(!isAccess){
        return (
            <Navigate to={HOME_ROUTE.path} replace />
        )
    }

    return <Navigate to={FINANCE_ROUTE.path} replace />
}
